import { fg } from '@atlaskit/platform-feature-flags';

import type { ConvoAiFeatureId } from '../utils/request/types';

// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
export function _getFetchCustomHeaders(): HeadersInit {
	const currentHost = window.location.origin;

	switch (true) {
		case currentHost === 'https://statlas.prod.atl-paas.net':
			// Update this to add custom headers when run in atlaskit branch deploys
			// ie.
			// {
			//   'X-CloudID': 'Magic string'
			// }
			return {};
		default:
			return {};
	}
}

export function deriveHost() {
	const {
		origin = '',
		port = '',
		hostname = '',
	} = typeof window.location !== 'undefined' ? window.location : {};

	if (
		(hostname === 'localhost' && port !== '8081') ||
		[
			'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
			'statlas.prod.atl-paas.net',
			'atlaskit.atlassian.com',
		].some((h) => hostname === h)
	) {
		return 'https://pug.jira-dev.com';
	}

	return origin;
}

export const convoAIStatelessApiURL = `${deriveHost()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
export const convoAIApiUrl = `${deriveHost()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/stream`;
export const convoAIRovoApiURL = `${deriveHost()}/gateway/api/assist/rovo/v1/editor/conversation`; // + `/${channelID}/message/stream` at the end;
export const convoAIAuditLogApiURL = `${deriveHost()}/gateway/api/ai/v2/ai-feature/audit-logs`;

export function deriveProactiveAIApiUrl() {
	return `${deriveHost()}/gateway/api/assist/ai/v2/ai-feature/proactive`;
}

export const getAPIName = (endpoint: string): string => {
	switch (endpoint) {
		case convoAIStatelessApiURL:
			return 'assistance-service';
		case convoAIApiUrl:
			return 'convo-ai';
		case convoAIRovoApiURL:
			return 'rovo-agent';
		case convoAIAuditLogApiURL:
			return 'audit-logs';
		case deriveProactiveAIApiUrl():
			return 'proactive-ai';
		default:
			return 'unknown-api';
	}
};

/**
 * This is part 1 of intent schema IDs that will be migrated to the Convo AI endpoint and will be
 * enabled when the feature flag `editor_ai_convo_ai_endpoint_202505` is enabled.
 */
const convoAIMigratedIntentsPart1 = new Set<ConvoAiFeatureId>([
	'find_action_items',
	'change_tone_casual',
	'change_tone_educational',
	'change_tone_empathetic',
	'change_tone_neutral',
	'change_tone_professional',
	'fix_spelling_grammar',
	'improve_writing',
	'make_longer',
	'rephrase',
	'make_shorter',
	'suggest_title',
	'summarize_writing',
	'translate',
]);

/**
 * This is part 2 of intent schema IDs that will be migrated to the Convo AI endpoint and will be
 * enabled when the feature flag `platform_editor_ai_convo_ai_migration_part2` is enabled.
 */
const convoAIMigratedIntentsPart2 = new Set<ConvoAiFeatureId>([
	// 'atlas_custom_shorten_intent_schema.json',
	'bitbucket_pr_description',
	'brainstorm',
	'issue_reformatter',
	'free_generate',
	'interrogation',
]);

export const isTargetingNewConvoAIEndpoint = (featureId?: ConvoAiFeatureId) => {
	if (!featureId) {
		return false;
	}
	return (
		(convoAIMigratedIntentsPart1.has(featureId) && fg('editor_ai_convo_ai_endpoint_202505')) ||
		(convoAIMigratedIntentsPart2.has(featureId) &&
			fg('platform_editor_ai_convo_ai_migration_part2'))
	);
};
